var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42v42H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.16 6.16)",
    fill: "#FFF",
    stroke: "#2e63ee",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.342,
    cy: 4.256,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.225,
    cy: 4.256,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.342,
    cy: 14.56,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.225,
    cy: 14.56,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.015,
    cy: 4.256,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.015,
    cy: 14.56,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.342,
    cy: 24.864,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.225,
    cy: 24.864,
    rx: 3.525,
    ry: 3.556
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.015,
    cy: 24.864,
    rx: 3.525,
    ry: 3.556
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategories);
export default __webpack_public_path__ + "static/media/all-categories.2a7a32eafb306a1f32ca85d3964a2ad5.svg";
export { ForwardRef as ReactComponent };